import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/homepages/sections/community_favorites'

const CmsHomepageSectionCommunityFavoritesApiV2 = {

  /**
   * Get list of Cms Homepage Section Community Favorites
   * Invoke `GET api/v2/admins/cms/homepages/sections/community_favorites'
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Create Cms Homepage Section Community Favorite
   * Invoke `POST api/v2/admins/cms/homepages/sections/community_favorites'
   * @param {string} label - label of all params get from modal
   */
  create: async (payload) => {
    const path = API_PATH

    const response = axios.post(path, payload)

    return response
  },
  /**
   * Update Cms Homepage Section Community Favorite
   * Invoke `PATCH api/v2/admins/cms/homepages/sections/community_favorites/:id'
   * @param {string} id - id of section community favorite
   * @param {boolean} is_active - is_active value get from table column
   */
  update: async ( id, payload) => {
    const path = `${API_PATH}/${id}`

    const response = axios.patch(path, payload)

    return response
  }
}

export default CmsHomepageSectionCommunityFavoritesApiV2
